import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  loadingObservable:Observable<boolean>;
  private $stateLoading:BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() { 
    this.loadingObservable = this.$stateLoading.asObservable();
  }

  opendLoader(): void{
    this.$stateLoading.next(true);
  }

  closeLoader(): void{
    this.$stateLoading.next(false);
  }
}
